export const UPDATE_APPROVED_SAGA = (payload: { id: number, newVal: string }) => ({
    type: 'UPDATE_APPROVED_SAGA',
    payload: payload
});  

  